import { Text } from '@chakra-ui/layout';
import { Box, Card, CardProps, Flex } from '@chakra-ui/react';
import { FC } from 'react';

interface IRedCardProps extends CardProps {
  smallHeading: string;
  heading: string;
}

export const RedWideCard: FC<IRedCardProps> = ({ smallHeading, heading, ...rest }) => {
  return (
    <Card mt={12} borderRadius="24px" p={{ base: 5, md: 8 }} w="full" backgroundColor="almostRed.500" {...rest}>
      <Flex flexDirection={{ base: 'column', lg: 'row' }} justifyContent="space-between" alignItems="center" gap={8}>
        <Box color="white" textAlign="left" w="full">
          <Text fontFamily="body" fontSize="xl">
            {smallHeading}
          </Text>
          <Text mt={1} fontFamily="heading" fontWeight="bold" fontSize="2xl" lineHeight="normal">
            {heading}
          </Text>
        </Box>
      </Flex>
    </Card>
  );
};
